import '../styles/app.scss';
import './_images';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		console.log('App ready');
	},
	false
);
